(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["article-body"]) return;
  try {
    
  (function () {
    var root = document.querySelector('[data-mm-article-content]');
    if (!root) return;
    root.querySelectorAll('meta, title, base, link, head').forEach(function (el) {
      el.remove();
    });
    root.querySelectorAll('body').forEach(function (el) {
      var parent = el.parentNode;
      while (el.firstChild) parent.insertBefore(el.firstChild, el);
      parent.removeChild(el);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cart-router"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var root = document.querySelector('[data-cart-router]');
    if (!root) return;

    if (window.Shopify && window.Shopify.designMode) return;

    var code         = (root.dataset.discount || '').trim();
    var urlWithItems = root.dataset.urlWithItems || '/checkout';
    var urlWhenEmpty = root.dataset.urlWhenEmpty || '/';

    function buildTarget(hasItems) {
      var dest = hasItems ? urlWithItems : urlWhenEmpty;
      if (code) {
        return '/discount/' + encodeURIComponent(code) + '?redirect=' + encodeURIComponent(dest);
      }
      return dest;
    }

    fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        window.location.replace(buildTarget(cart.item_count > 0));
      })
      .catch(function () {
        window.location.replace(buildTarget(false));
      });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["holiday-bar"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('.hb').forEach(function (bar) {
      var dismissKey = bar.getAttribute('data-dismiss-key');
      if (dismissKey) {
        try {
          if (localStorage.getItem(dismissKey) === '1') {
            bar.classList.add('is-hidden');
            return;
          }
        } catch (e) {}
        var closeBtn = bar.querySelector('[data-hb-close]');
        if (closeBtn) closeBtn.addEventListener('click', function () {
          bar.classList.add('is-hidden');
          try { localStorage.setItem(dismissKey, '1'); } catch (e) {}
        });
      }

      bar.querySelectorAll('[data-mm-countdown]').forEach(function (el) {
        if (el.dataset.hbBound === '1') return;
        el.dataset.hbBound = '1';
        var total = parseInt(el.dataset.minutes, 10) * 60;
        var remaining = total;
        function pad(n) { return String(n).padStart(2, '0'); }
        function tick() {
          var h = Math.floor(remaining / 3600);
          var m = Math.floor((remaining % 3600) / 60);
          var s = remaining % 60;
          el.textContent = '00 : ' + pad(h) + ' : ' + pad(m) + ' : ' + pad(s);
          remaining = remaining <= 0 ? total : remaining - 1;
        }
        tick();
        setInterval(tick, 1000);
      });

      if (bar.getAttribute('data-rotate') !== 'true') return;
      var msgs = bar.querySelectorAll('[data-hb-msg]');
      if (msgs.length < 2) return;

      var styles = getComputedStyle(bar);
      var interval = parseInt(styles.getPropertyValue('--hb-rotate-ms'), 10) || 4000;
      var fadeMs   = parseInt(styles.getPropertyValue('--hb-fade-ms'), 10) || 400;
      var i = 0;

      setInterval(function () {
        var current = msgs[i];
        i = (i + 1) % msgs.length;
        var next = msgs[i];
        current.classList.remove('is-active');
        setTimeout(function () { next.classList.add('is-active'); }, fadeMs);
      }, interval);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page-utility"]) return;
  try {
    
  (function () {
    var node = document.querySelector('[data-mm-redirect]');
    if (!node) return;
    var url = node.getAttribute('data-redirect-url');
    if (!url) return;
    var delay = parseInt(node.getAttribute('data-redirect-delay'), 10);
    if (isNaN(delay) || delay < 0) delay = 5;
    var countdown = node.querySelector('[data-mm-countdown]');
    var remaining = delay;

    function go() {
      window.location.href = url;
    }

    function tick() {
      if (remaining <= 0) {
        if (countdown) countdown.textContent = '';
        go();
        return;
      }
      if (countdown) countdown.textContent = '· redirecting in ' + remaining + 's';
      remaining -= 1;
      window.setTimeout(tick, 1000);
    }

    if (delay === 0) {
      go();
    } else {
      tick();
    }
  })();

  (function () {
    // Smart 404 — key off the marker rendered only on genuine 404 pages.
    var node = document.querySelector('[data-mm-suggest]');
    if (!node) return;

    var minScore = parseFloat(node.getAttribute('data-min-score'));
    if (isNaN(minScore)) minScore = 60;
    if (minScore > 1) minScore = minScore / 100; // stored as a percent (e.g. 60)

    var badPath = window.location.pathname.replace(/\/+$/, '');
    if (!badPath || badPath === '/') return;

    var slug = badPath.split('/').pop();
    var query = decodeURIComponent(slug).replace(/[-_]+/g, ' ').trim();
    if (query.length < 4) return; // too short to match confidently

    var url = '/search/suggest.json'
      + '?q=' + encodeURIComponent(query)
      + '&resources[type]=product,collection,article,page'
      + '&resources[limit]=4'
      + '&resources[options][unavailable_products]=last';

    fetch(url, { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var res = (data && data.resources && data.resources.results) || {};
        var hits = []
          .concat(res.articles || [], res.products || [], res.pages || [], res.collections || [])
          .filter(function (h) { return h && h.url; });
        if (!hits.length) return;

        var a = badPath.toLowerCase(), sl = slug.toLowerCase();
        var best = null, bestScore = 0;

        hits.forEach(function (h) {
          var p = h.url.split('?')[0].replace(/\/+$/, '').toLowerCase();
          var score = 0;
          if (p.indexOf(a) === 0) score = a.length / p.length;                 // broken is a prefix of real
          else if (a.indexOf(p) === 0 && p.length > 10) score = p.length / a.length; // real is a prefix of broken
          else {                                                               // shared slug
            var s = p.split('/').pop();
            if (s.indexOf(sl) === 0 || sl.indexOf(s) === 0) {
              score = Math.min(s.length, sl.length) / Math.max(s.length, sl.length) * 0.9;
            }
          }
          if (score > bestScore) { bestScore = score; best = p; }
        });

        if (best && bestScore >= minScore && best !== a) window.location.replace(best);
      })
      .catch(function () { /* fail silently -> normal 404 */ });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pdp-aov-boosters"] && !Shopify.designMode) return;
  try {
    
  (function() {
    // ── Tier ATC ────────────────────────────────────────────────────────
    var tierAtc = document.querySelector('[data-mm-aov-atc]');
    if (tierAtc) {
      tierAtc.addEventListener('click', function() {
        var checked = document.querySelector('[data-mm-tier-input]:checked');
        if (!checked) return;
        var vid = checked.getAttribute('data-variant-id');
        var qty = parseInt(checked.getAttribute('data-quantity'), 10) || 1;
        if (!vid) return;
        tierAtc.disabled = true;
        var origText = tierAtc.innerHTML;
        tierAtc.textContent = 'Adding…';
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: [{ id: parseInt(vid, 10), quantity: qty }] })
        })
        .then(function(r) { return r.json(); })
        .then(function() {
          document.dispatchEvent(new CustomEvent('mm:cart:updated'));
          tierAtc.textContent = '✓ Added';
          window.mmOpenCart();
          setTimeout(function() {
            tierAtc.disabled = false;
            tierAtc.innerHTML = origText;
          }, 500);
        })
        .catch(function() {
          tierAtc.disabled = false;
          tierAtc.innerHTML = origText;
        });
      });
    }

    // ── FBT total + ATC ─────────────────────────────────────────────────
    var fbt = document.querySelector('[data-mm-fbt]');
    if (fbt) {
      var inputs = Array.from(fbt.querySelectorAll('[data-mm-fbt-input]'));
      var totalEl = fbt.querySelector('[data-mm-fbt-total]');
      var fbtAtc  = fbt.querySelector('[data-mm-fbt-atc]');

      function fmtMoney(cents) {
        if (window.mmMoney) return window.mmMoney(cents);
        return '$' + (cents / 100).toFixed(2);
      }
      function recalc() {
        var total = 0;
        inputs.forEach(function(i) {
          if (i.checked) total += parseInt(i.getAttribute('data-price'), 10) || 0;
        });
        if (totalEl) totalEl.textContent = fmtMoney(total);
      }
      inputs.forEach(function(i) { i.addEventListener('change', recalc); });
      recalc();

      if (fbtAtc) {
        fbtAtc.addEventListener('click', function() {
          var items = inputs
            .filter(function(i) { return i.checked && i.getAttribute('data-variant-id'); })
            .map(function(i) { return { id: parseInt(i.getAttribute('data-variant-id'), 10), quantity: 1 }; });
          if (!items.length) return;
          fbtAtc.disabled = true;
          var orig = fbtAtc.textContent;
          fbtAtc.textContent = 'Adding…';
          fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({ items: items })
          })
          .then(function(r) { return r.json(); })
          .then(function() {
            document.dispatchEvent(new CustomEvent('mm:cart:updated'));
            fbtAtc.textContent = '✓ Added';
            window.mmOpenCart();
            setTimeout(function() { fbtAtc.disabled = false; fbtAtc.textContent = orig; }, 500);
          })
          .catch(function() { fbtAtc.disabled = false; fbtAtc.textContent = orig; });
        });
      }
    }

    // ── Free shipping bar (live update via fetch on cart change) ────────
    var bar = document.querySelector('[data-mm-shipbar]');
    if (bar) {
      var threshold = parseInt(bar.getAttribute('data-threshold'), 10) || 0;
      var fillEl = bar.querySelector('[data-mm-shipbar-fill]');
      var textEl = bar.querySelector('[data-mm-shipbar-text]');

      function fmt(cents) { if (window.mmMoney) return window.mmMoney(cents); return '$' + (cents / 100).toFixed(2); }
      function update(totalPrice) {
        var pct = Math.min(100, Math.round((totalPrice / threshold) * 100));
        if (fillEl) fillEl.style.width = pct + '%';
        if (textEl) {
          if (totalPrice < threshold) {
            textEl.innerHTML = 'Add <strong>' + fmt(threshold - totalPrice) + '</strong> more for <strong>FREE shipping</strong>';
          } else {
            textEl.innerHTML = '🎉 You\'ve unlocked <strong>FREE shipping</strong>';
          }
        }
      }
      function refresh() {
        fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
          .then(function(r) { return r.json(); })
          .then(function(c) { update(c.total_price); })
          .catch(function() {});
      }
      document.addEventListener('mm:cart:updated', refresh);
      // Also catch native form submits or other ATC events
      document.addEventListener('cart:updated', refresh);
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pdp-blade-swap"] && !Shopify.designMode) return;
  try {
    
  (function() {
    function initAll() {
      document.querySelectorAll('[data-mm-bswap]').forEach(initSection);
    }

    function initSection(root) {
      if (root.getAttribute('data-mm-bswap-bound') === '1') return;
      root.setAttribute('data-mm-bswap-bound', '1');

      var mode = root.getAttribute('data-mode');
      var tabs = root.querySelectorAll('[data-mm-bswap-tab]');
      var panels = root.querySelectorAll('[data-mm-bswap-panel]');

      function pauseAll() {
        root.querySelectorAll('video').forEach(function(v) { v.pause(); });
      }
      function activePanel() {
        return root.querySelector('[data-mm-bswap-panel]:not([hidden])');
      }
      function playActive() {
        if (mode !== 'autoplay') return;
        var panel = activePanel();
        if (!panel) return;
        var v = panel.querySelector('video');
        if (v) {
          v.muted = true;
          var p = v.play();
          if (p && p.catch) p.catch(function() {});
        }
      }

      tabs.forEach(function(tab) {
        tab.addEventListener('click', function() {
          var key = tab.getAttribute('data-mm-bswap-tab');
          tabs.forEach(function(t) {
            var on = t === tab;
            t.classList.toggle('is-active', on);
            t.setAttribute('aria-selected', on ? 'true' : 'false');
          });
          panels.forEach(function(p) {
            p.hidden = p.getAttribute('data-mm-bswap-panel') !== key;
          });
          pauseAll();
          playActive();
        });
      });

      root.querySelectorAll('[data-mm-bswap-play]').forEach(function(btn) {
        btn.addEventListener('click', function() {
          var panel = btn.closest('[data-mm-bswap-panel]');
          if (!panel) return;
          panel.classList.add('is-playing');
          var v = panel.querySelector('video');
          if (v) {
            v.controls = true;
            var p = v.play();
            if (p && p.catch) p.catch(function() {});
          }
        });
      });

      // Autoplay only while on screen — saves battery, feels intentional.
      pauseAll();
      if (mode === 'autoplay' && 'IntersectionObserver' in window) {
        var io = new IntersectionObserver(function(entries) {
          entries.forEach(function(entry) {
            if (entry.isIntersecting) { playActive(); } else { pauseAll(); }
          });
        }, { threshold: 0.25 });
        io.observe(root);
      } else {
        playActive();
      }
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll);
    } else {
      initAll();
    }
    document.addEventListener('shopify:section:load', initAll);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pdp-compare-table"] && !Shopify.designMode) return;
  try {
    
  (function () {
    // The ATC button posts through the buy box via form="mm-buybox". On any page
    // where that form is absent (a product template without the buy box, or the
    // section dropped somewhere else) a submit button with a dangling `form`
    // does nothing at all — so demote it to a plain button and let the
    // delegated add-to-cart handler use its data-variant instead.
    function guard() {
      if (document.getElementById('mm-buybox')) return;
      document.querySelectorAll('.mm-ctbl__atc[type="submit"]').forEach(function (btn) {
        if (!btn.dataset.variant) return;
        btn.type = 'button';
        btn.removeAttribute('form');
      });
    }

    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', guard);
    else guard();
    document.addEventListener('shopify:section:load', guard);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pdp-feature-carousel"] && !Shopify.designMode) return;
  try {
    
  (function () {
    'use strict';

    function initFcar(el) {
      if (el.__mmFcar) return;
      el.__mmFcar = true;
      var track = el.querySelector('[data-mm-fcar-track]');
      if (!track) return;
      var cards = track.querySelectorAll('[data-mm-fcar-card]');
      var prev = el.querySelector('[data-mm-fcar-prev]');
      var next = el.querySelector('[data-mm-fcar-next]');
      var now = el.querySelector('[data-mm-fcar-now]');
      var fill = el.querySelector('[data-mm-fcar-fill]');
      var hint = el.querySelector('[data-mm-fcar-hint]');

      function step() {
        if (!cards.length) return 0;
        var gap = parseFloat(getComputedStyle(track).columnGap) || 0;
        return cards[0].offsetWidth + gap;
      }

      function sync() {
        var max = track.scrollWidth - track.clientWidth;
        if (prev) prev.disabled = track.scrollLeft <= 0;
        if (next) next.disabled = track.scrollLeft >= max - 1;
        if (fill && max > 0) {
          var frac = Math.min(1, Math.max(0, track.scrollLeft / max));
          /* Start with one card's share so the bar never reads empty */
          fill.style.width = ((1 / cards.length + frac * (1 - 1 / cards.length)) * 100) + '%';
        }
        if (cards.length && step() > 0) {
          var idx = Math.min(cards.length - 1, Math.max(0, Math.round(track.scrollLeft / step())));
          if (now) now.textContent = (idx + 1 < 10 ? '0' : '') + (idx + 1);
          cards.forEach(function (c, j) {
            c.classList.toggle('mm-fcar__card--active', j === idx);
          });
        }
      }

      var ticking = false;
      track.addEventListener('scroll', function () {
        if (hint && !hint.hasAttribute('data-hidden')) hint.setAttribute('data-hidden', '');
        if (ticking) return;
        ticking = true;
        requestAnimationFrame(function () { ticking = false; sync(); });
      }, { passive: true });

      if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
      if (next) next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });
      sync();
    }

    function init(scope) {
      var root = (scope && scope.querySelectorAll) ? scope : document;
      root.querySelectorAll('[data-mm-fcar]').forEach(initFcar);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { init(document); });
    } else {
      init(document);
    }
    document.addEventListener('shopify:section:load', function (e) { init(e.target); });

    /* Editor: clicking a feature block scrolls its card into view */
    document.addEventListener('shopify:block:select', function (e) {
      var card = e.target && e.target.querySelector &&
        e.target.querySelector('[data-mm-fcar-card][data-block-id="' + e.detail.blockId + '"]');
      if (card) card.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pdp-founder-trust"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var BOUND = 'data-mm-ftrust-bound';

    function activate(wrap) {
      var poster = wrap.querySelector('[data-mm-ftrust-poster]');
      var player = wrap.querySelector('[data-mm-ftrust-player]');
      if (!player) return;
      var inner = wrap.querySelector('.mm-ftrust__video-inner');
      var embed = inner ? inner.getAttribute('data-embed') : null;

      var video = player.querySelector('video');
      if (video) {
        setPoster(video);
        player.hidden = false;
        if (poster) poster.style.display = 'none';
        try { video.play(); } catch (e) {}
        return;
      }
      if (embed && !player.querySelector('iframe')) {
        var iframe = document.createElement('iframe');
        iframe.className = 'mm-ftrust__media-el mm-ftrust__iframe';
        iframe.setAttribute('src', embed);
        iframe.setAttribute('allow', 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share');
        iframe.setAttribute('allowfullscreen', '');
        iframe.setAttribute('title', 'Founder video');
        player.appendChild(iframe);
        player.hidden = false;
        if (poster) poster.style.display = 'none';
      }
    }

    // Starts buffering the hidden <video> once the section is getting close
    // to the viewport, so a real tap on play starts instantly instead of a
    // few seconds of black while the first bytes arrive. Nothing loads at
    // first paint — this only fires once IntersectionObserver reports the
    // section is within rootMargin of the viewport.
    function setPoster(video) {
      var p = video.getAttribute('data-mm-poster');
      if (p && !video.getAttribute('poster')) video.setAttribute('poster', p);
    }

    function warm(wrap) {
      var player = wrap.querySelector('[data-mm-ftrust-player]');
      var video = player ? player.querySelector('video') : null;
      if (!video || video.getAttribute('data-mm-warmed') === '1') return;
      video.setAttribute('data-mm-warmed', '1');
      setPoster(video);
      video.preload = 'auto';
      try { video.load(); } catch (e) {}
    }

    function bind() {
      document.querySelectorAll('[data-mm-ftrust-video][data-mode="click"]').forEach(function (wrap) {
        if (wrap.getAttribute(BOUND) === '1') return;
        var btn = wrap.querySelector('[data-mm-ftrust-play]');
        if (!btn) return;
        wrap.setAttribute(BOUND, '1');
        btn.addEventListener('click', function () { activate(wrap); });

        if ('IntersectionObserver' in window) {
          var io = new IntersectionObserver(function (entries) {
            entries.forEach(function (entry) {
              if (entry.isIntersecting) { warm(wrap); io.disconnect(); }
            });
          }, { rootMargin: '600px 0px' });
          io.observe(wrap);
        } else {
          warm(wrap);
        }
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', bind);
    } else {
      bind();
    }
    document.addEventListener('shopify:section:load', bind);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pdp-how-to"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var BOUND = 'data-mm-howto-bound';

    function activate(wrap) {
      var poster = wrap.querySelector('[data-mm-howto-poster]');
      var player = wrap.querySelector('[data-mm-howto-player]');
      if (!player) return;
      var embed = wrap.getAttribute('data-embed');

      var video = player.querySelector('video');
      if (video) {
        player.hidden = false;
        if (poster) poster.style.display = 'none';
        try { video.play(); } catch (e) {}
        return;
      }
      if (embed && !player.querySelector('iframe')) {
        var iframe = document.createElement('iframe');
        iframe.className = 'mm-howto__media mm-howto__iframe';
        iframe.setAttribute('src', embed);
        iframe.setAttribute('allow', 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share');
        iframe.setAttribute('allowfullscreen', '');
        iframe.setAttribute('title', 'How to use');
        player.appendChild(iframe);
        player.hidden = false;
        if (poster) poster.style.display = 'none';
      }
    }

    function bind() {
      document.querySelectorAll('[data-mm-howto-video][data-mode="click"]').forEach(function (wrap) {
        if (wrap.getAttribute(BOUND) === '1') return;
        var btn = wrap.querySelector('[data-mm-howto-play]');
        if (!btn) return;
        wrap.setAttribute(BOUND, '1');
        btn.addEventListener('click', function () { activate(wrap); });
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', bind);
    } else {
      bind();
    }
    document.addEventListener('shopify:section:load', bind);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pdp-review-objections"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var BOUND = 'data-mm-robj-bound';

    function smooth() {
      return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches
        ? 'auto'
        : 'smooth';
    }

    function setup(car) {
      var track = car.querySelector('[data-mm-robj-track]');
      if (!track) return;
      var prev = car.querySelector('[data-mm-robj-prev]');
      var next = car.querySelector('[data-mm-robj-next]');
      var dots = car.querySelector('[data-mm-robj-dots]');
      var bar = car.querySelector('[data-mm-robj-bar]');
      var cards = Array.prototype.slice.call(track.children);
      if (!cards.length) return;

      // Read live rather than cache: card width is a percentage of the track,
      // so it changes on resize and on the 700px breakpoint.
      function cardStep() {
        var cs = getComputedStyle(track);
        var gap = parseFloat(cs.columnGap || cs.gap || '16') || 16;
        return cards[0].getBoundingClientRect().width + gap;
      }
      function perView() {
        var step = cardStep();
        if (!step) return 1;
        return Math.max(1, Math.round(track.clientWidth / step));
      }
      function pageStep() { return cardStep() * perView(); }
      function pageCount() { return Math.max(1, Math.ceil(cards.length / perView())); }
      function currentPage() {
        var step = pageStep();
        if (!step) return 0;
        return Math.min(pageCount() - 1, Math.max(0, Math.round(track.scrollLeft / step)));
      }
      function goTo(page) {
        track.scrollTo({ left: page * pageStep(), behavior: smooth() });
      }

      function renderDots() {
        if (!dots) return;
        var n = pageCount();
        if (dots.children.length === n) return;
        dots.textContent = '';
        for (var i = 0; i < n; i++) {
          var b = document.createElement('button');
          b.type = 'button';
          b.className = 'mm-robj__dot';
          b.setAttribute('data-page', i);
          b.setAttribute('aria-label', 'Go to review page ' + (i + 1) + ' of ' + n);
          dots.appendChild(b);
        }
      }

      function update() {
        var page = currentPage();
        var single = pageCount() < 2;
        var maxScroll = track.scrollWidth - track.clientWidth - 1;
        // Everything inside the bar hides at one page, so drop the bar itself
        // rather than leaving its margin behind as an unexplained gap.
        if (bar) bar.hidden = single;
        if (prev) { prev.hidden = single; prev.disabled = track.scrollLeft <= 1; }
        if (next) { next.hidden = single; next.disabled = track.scrollLeft >= maxScroll; }
        if (dots) {
          dots.hidden = single;
          Array.prototype.forEach.call(dots.children, function (d, i) {
            if (i === page) d.setAttribute('aria-current', 'true');
            else d.removeAttribute('aria-current');
          });
        }
      }

      if (prev) prev.addEventListener('click', function () { goTo(Math.max(0, currentPage() - 1)); });
      if (next) next.addEventListener('click', function () { goTo(Math.min(pageCount() - 1, currentPage() + 1)); });
      if (dots) {
        dots.addEventListener('click', function (e) {
          var dot = e.target && e.target.closest ? e.target.closest('.mm-robj__dot') : null;
          if (dot) goTo(parseInt(dot.getAttribute('data-page'), 10) || 0);
        });
      }

      var raf = 0;
      track.addEventListener('scroll', function () {
        if (raf) return;
        raf = requestAnimationFrame(function () { raf = 0; update(); });
      }, { passive: true });

      function remeasure() { renderDots(); update(); }
      if (window.ResizeObserver) new ResizeObserver(remeasure).observe(track);
      else window.addEventListener('resize', remeasure);

      remeasure();
    }

    function init() {
      document.querySelectorAll('[data-mm-robj-carousel]').forEach(function (car) {
        if (car.getAttribute(BOUND) === '1') return;
        car.setAttribute(BOUND, '1');
        setup(car);
      });
    }

    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
    else init();
    document.addEventListener('shopify:section:load', init);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pdp-see-it-in-action"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var BTN_BOUND_ATTR  = 'data-mm-sia-bound';
    var CLOSE_BOUND_ATTR = 'data-mm-sia-close-bound';
    var ESC_BOUND = false;

    // ── Move "in-hero" / "next-to-title" buttons to their anchor (idempotent) ──
    function relocateButtons() {
      var hero = document.getElementById('mm-main-gallery');
      document.querySelectorAll('[data-mm-sia-anchor="in-hero"]').forEach(function(btn) {
        if (hero && !hero.contains(btn)) hero.appendChild(btn);
      });
      document.querySelectorAll('[data-mm-sia-anchor="next-to-title"]').forEach(function(btn) {
        var title = document.querySelector('.mm-buybox__name');
        if (!title) return;
        var wrap = title.parentNode.querySelector('.mm-sia__title-wrap');
        if (!wrap) {
          wrap = document.createElement('div');
          wrap.className = 'mm-sia__title-wrap';
          title.parentNode.insertBefore(wrap, title);
          wrap.appendChild(title);
        }
        if (!wrap.contains(btn)) wrap.appendChild(btn);
      });
    }

    function getModal() { return document.querySelector('[data-mm-sia-modal]'); }

    function openModal() {
      var modal = getModal();
      if (!modal) return;
      modal.dataset.mmSiaLastFocus = '';
      try { modal._lastFocus = document.activeElement; } catch (e) {}
      modal.hidden = false;
      document.body.style.overflow = 'hidden';
      var closeBtn = modal.querySelector('.mm-sia__close');
      if (closeBtn) closeBtn.focus({ preventScroll: true });
    }

    function closeModal() {
      var modal = getModal();
      if (!modal) return;
      modal.hidden = true;
      document.body.style.overflow = '';
      var player = modal.querySelector('[data-mm-sia-player]');
      if (player) {
        var video = player.querySelector('video');
        if (video) { video.pause(); try { video.currentTime = 0; } catch (e) {} }
        var iframe = player.querySelector('iframe');
        if (iframe) {
          var src = iframe.getAttribute('src');
          iframe.setAttribute('src', src);
        }
      }
      if (modal._lastFocus && modal._lastFocus.focus) modal._lastFocus.focus({ preventScroll: true });
    }

    function bindOpeners() {
      document.querySelectorAll('[data-mm-sia-open]').forEach(function(btn) {
        if (btn.getAttribute(BTN_BOUND_ATTR) === '1') return;
        btn.setAttribute(BTN_BOUND_ATTR, '1');
        btn.addEventListener('click', openModal);
      });
    }

    function bindClosers() {
      var modal = getModal();
      if (!modal) return;
      modal.querySelectorAll('[data-mm-sia-close]').forEach(function(el) {
        if (el.getAttribute(CLOSE_BOUND_ATTR) === '1') return;
        el.setAttribute(CLOSE_BOUND_ATTR, '1');
        el.addEventListener('click', closeModal);
      });
    }

    function bindEscape() {
      if (ESC_BOUND) return;
      ESC_BOUND = true;
      document.addEventListener('keydown', function(e) {
        var modal = getModal();
        if (modal && e.key === 'Escape' && !modal.hidden) closeModal();
      });
    }

    function init() {
      relocateButtons();
      bindOpeners();
      bindClosers();
      bindEscape();
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }

    // ── Re-run on Shopify editor section reloads so the button never disappears ──
    document.addEventListener('shopify:section:load', init);
    document.addEventListener('shopify:section:unload', function() {
      // Modal may have been torn down with the section — reset body lock just in case
      document.body.style.overflow = '';
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pdp-video-carousel"] && !Shopify.designMode) return;
  try {
    
  (function () {
    'use strict';

    function initVcar(el) {
      if (el.__mmVcar) return;
      el.__mmVcar = true;

      var track = el.querySelector('[data-mm-vcar-track]');
      if (!track) return;
      var fill = el.querySelector('[data-mm-vcar-fill]');
      var prev = el.querySelector('[data-mm-vcar-prev]');
      var next = el.querySelector('[data-mm-vcar-next]');
      var toggle = el.querySelector('[data-mm-vcar-toggle]');
      var cards = track.querySelectorAll('[data-mm-vcar-card]');
      var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var isMobile = window.matchMedia && window.matchMedia('(max-width: 699px)').matches;
      var speed = isMobile
        ? (parseFloat(el.getAttribute('data-speed-mobile')) || 70)
        : (parseFloat(el.getAttribute('data-speed')) || 40); // px/sec
      var half = 0; // width of one full (non-duplicated) pass
      var manualPause = false;

      // Auto-scroll only while the strip is actually on screen and the tab
      // is visible — same discipline as every other autoplay/animation loop
      // in this theme (pdp-blade-swap's IntersectionObserver, the home hero
      // carousel's visibilitychange gate, mm-stat-rings' IO-started rAF).
      // The rAF chain itself stops being scheduled at all when either signal
      // says "not visible," rather than running forever and no-opping.

      if (toggle) {
        if (reduceMotion || speed <= 0) {
          toggle.hidden = true;
        } else {
          toggle.addEventListener('click', function () {
            manualPause = !manualPause;
            toggle.setAttribute('aria-pressed', manualPause ? 'true' : 'false');
            toggle.setAttribute('aria-label', manualPause ? 'Resume auto-scroll' : 'Pause auto-scroll');
          });
        }
      }

      // Tiles open the "enlarge video + show product" popup — the same
      // engine as the PDP hero's video carousel (pdp-video-carousel.js),
      // reused here via its root.__mmVcOpen(id) hook. Delegated so the
      // cloned (pass 2) tiles open too.
      var vpopRoot = document.getElementById('mm-vcar-vc-' + el.id.replace(/^mm-vcar-/, ''));
      track.addEventListener('click', function (e) {
        var tile = e.target.closest('[data-mm-vcar-open]');
        if (!tile || !track.contains(tile)) return;
        if (!vpopRoot || typeof vpopRoot.__mmVcOpen !== 'function') return;
        vpopRoot.__mmVcOpen(tile.getAttribute('data-mm-vcar-open'));
      });

      // Inline muted preview playback: a <video> exists only on tiles near the
      // viewport (strip on screen + tile within ~1 tile of the visible edge).
      var previewIO = null;
      var stripSeen = false;
      var medias = function () { return track.querySelectorAll('[data-mm-vcar-src]'); };

      // Preview quality tiers — 'hi' (normal rendition, every tile streams),
      // 'lo' (smallest mp4 Shopify made when one exists, data-mm-vcar-src-lo,
      // and ONLY the tiles currently inside the strip's viewport stream —
      // Shopify's smallest rendition is often 480p, so fewer concurrent
      // streams is the real bandwidth lever), 'off' (static posters only).
      //   terrible connection → off; mediocre → start on lo; otherwise hi.
      //   At runtime, a strip whose tiles keep buffering steps down one tier
      //   (hi → lo → off), so a bad network ends on posters instead of a row
      //   of spinning/frozen tiles. The step-down is remembered for the
      //   session so the next page doesn't re-run the experiment.
      var TIERS = ['hi', 'lo', 'off'];
      var syncAll = function () {}; // real one assigned below once the strip observer exists
      var visIO = null;
      function markVis() {
        var tr = track.getBoundingClientRect(), pad = tr.width * 0.25;
        medias().forEach(function (m) {
          var r = m.getBoundingClientRect();
          m.__mmVis = r.right > tr.left - pad && r.left < tr.right + pad;
        });
      }
      function ensureVisIO() {
        if (visIO || !('IntersectionObserver' in window)) return;
        markVis();
        visIO = new IntersectionObserver(function (entries) {
          entries.forEach(function (e) { e.target.__mmVis = e.isIntersecting; });
          if (tier === 'lo' || capN > 0) syncAll();
        }, { root: track, rootMargin: '0px 25% 0px 25%', threshold: 0 });
        medias().forEach(function (m) { visIO.observe(m); });
      }
      // Merchant controls (section settings): forced quality + stream cap.
      var forcedMode = el.getAttribute('data-preview-mode') || 'auto';
      var capN = parseInt(el.getAttribute('data-preview-max'), 10) || 0;
      function wantsPlay(media) { return (tier === 'hi' && capN === 0) || media.__mmVis === true; }
      function startTier() {
        try {
          if (reduceMotion) return 'off';
          if (forcedMode === 'posters') return 'off';
          if (forcedMode === 'lite') return 'lo';
          var saved = sessionStorage.getItem('mm_vcar_tier');
          if (saved && TIERS.indexOf(saved) > -1) return saved;
          var c = navigator.connection || navigator.mozConnection || navigator.webkitConnection;
          var nav = performance.getEntriesByType && performance.getEntriesByType('navigation')[0];
          var docMs = nav && nav.responseEnd > 0 ? nav.responseEnd - nav.requestStart : 0;
          if (c && c.saveData) return 'off';
          if (window.matchMedia && window.matchMedia('(prefers-reduced-data: reduce)').matches) return 'off';
          if (c && /(^|-)2g$/.test(c.effectiveType || '')) return 'off';
          if (c && c.downlink && c.downlink < 0.5) return 'off';
          if (docMs > 6000) return 'off';
          if (c && c.effectiveType === '3g') return 'lo';
          if (c && c.downlink && c.downlink < 2) return 'lo';
          if (typeof window.mmSlowNet === 'function' && window.mmSlowNet()) return 'lo';
        } catch (e) {}
        return 'hi';
      }
      var tier = startTier();
      var stallScore = 0;
      // Buffering right after a tier starts is expected, not evidence — the
      // watchdog ignores stalls for this long after (re)starting streams.
      var graceUntil = 0;
      function grace(ms) { graceUntil = Date.now() + ms; }
      function srcFor(media) {
        var lo = media.getAttribute('data-mm-vcar-src-lo');
        return (tier === 'lo' && lo) ? lo : media.getAttribute('data-mm-vcar-src');
      }
      function stepDown() {
        var next = TIERS[TIERS.indexOf(tier) + 1];
        if (!next) return;
        tier = next;
        stallScore = 0;
        grace(10000);
        try { sessionStorage.setItem('mm_vcar_tier', tier); } catch (e) {}
        if (tier === 'off') { medias().forEach(stopTile); return; }
        // 'lo': off-screen tiles release their stream (syncAll), on-screen
        // ones swap to the smaller rendition when there is one.
        ensureVisIO();
        syncAll();
        medias().forEach(function (media) {
          var v = media.__mmV;
          if (!v) return;
          var want = srcFor(media);
          if (v.getAttribute('src') === want) return;
          media.__mmLastT = -1; media.__mmStuck = 0;
          v.src = want; // keeps the current frame as poster until the smaller file plays
          kick(media);
        });
      }

      // Every tile must keep playing, not just start: browsers pause or
      // starve muted autoplay videos on their own (Safari's per-page media
      // limits, iOS Low Power Mode, a "Never Auto-Play" site setting, decoder
      // pressure from a dozen streams). kick() re-issues play() on a tile
      // that is still supposed to be playing; the gesture fallback and the
      // watchdog below call it whenever a tile is found paused or frozen.
      function kick(media) {
        var v = media.__mmV;
        if (!v || !stripSeen || document.hidden || tier === 'off') return;
        var p = v.play();
        if (p && p.catch) p.catch(function () { needsGesture = true; });
      }
      function playTile(media) {
        if (media.__mmV || tier === 'off') return;
        var v = document.createElement('video');
        v.className = 'mm-vcar__media-el mm-vcar__preview';
        v.muted = true; v.loop = true; v.playsInline = true; v.autoplay = true; v.defaultMuted = true;
        v.setAttribute('muted', ''); v.setAttribute('playsinline', ''); v.setAttribute('autoplay', ''); v.setAttribute('loop', '');
        v.setAttribute('aria-hidden', 'true'); v.setAttribute('disableremoteplayback', '');
        v.preload = 'auto';
        var img = media.querySelector('img');
        if (img) v.poster = img.currentSrc || img.src;
        v.src = srcFor(media);
        media.insertBefore(v, media.firstChild);
        media.__mmV = v;
        media.__mmLastT = -1; media.__mmStuck = 0;
        v.addEventListener('playing', function () { media.classList.add('is-playing'); });
        // A pause we didn't ask for (browser/system) → resume right away.
        v.addEventListener('pause', function () {
          if (media.__mmV !== v || v.ended) return;
          setTimeout(function () { if (media.__mmV === v && v.paused) kick(media); }, 150);
        });
        kick(media);
      }
      function stopTile(media) {
        var v = media.__mmV;
        if (!v) return;
        media.__mmV = null; // clear first so the 'pause' handler above doesn't re-kick
        v.pause(); v.removeAttribute('src'); v.load();
        if (v.parentNode) v.parentNode.removeChild(v);
        media.classList.remove('is-playing');
      }
      // Autoplay refused (Safari "Never Auto-Play", iOS Low Power Mode): the
      // first real interaction anywhere on the page is allowed to start media,
      // so use it to start every tile at once.
      var needsGesture = false;
      function onFirstGesture() {
        if (!needsGesture) return;
        needsGesture = false;
        medias().forEach(kick);
      }
      ['pointerdown', 'touchend', 'keydown'].forEach(function (ev) {
        document.addEventListener(ev, onFirstGesture, { passive: true, capture: true });
      });
      // Watchdog (strip on screen only, every 2.5s):
      //   paused tile → kick; playhead frozen while buffering (readyState < 3)
      //   → counts as a network stall; frozen with data (decoder hiccup) →
      //   kick, then reload if it stays stuck. Three stalled tile-ticks step
      //   the whole strip down a quality tier.
      var watchTimer = null;
      function watch() {
        var stalledNow = 0;
        medias().forEach(function (media) {
          var v = media.__mmV;
          if (!v) return;
          if (v.paused) { kick(media); return; }
          var frozen = v.currentTime === media.__mmLastT && !v.ended;
          media.__mmLastT = v.currentTime;
          if (!frozen) { media.__mmStuck = 0; return; }
          if (v.readyState < 3) { stalledNow++; return; }
          media.__mmStuck++;
          if (media.__mmStuck === 2) kick(media);
          else if (media.__mmStuck >= 4) { media.__mmStuck = 0; v.load(); kick(media); }
        });
        // Clean ticks heal the score so a one-off hiccup never demotes a
        // healthy connection; sustained buffering across tiles does.
        if (Date.now() < graceUntil) return;
        stallScore = stalledNow ? stallScore + stalledNow : Math.max(0, stallScore - 1);
        if (stallScore >= 3) stepDown();
      }
      if (tier !== 'off' && 'IntersectionObserver' in window) {
        // 'hi': every tile plays while the strip is on screen (so scrolling
        // never reveals a still). 'lo': only tiles inside the strip viewport.
        // All are released when the strip leaves view / the tab hides.
        // Tiles start a few at a time, nearest the strip's centre first. Creating
        // a dozen-plus <video> elements in one task stalls the main thread (a tap
        // or scroll that lands meanwhile waits behind them), and the centre tiles
        // are the ones actually on screen.
        var startQueue = [], startTimer = null;
        function pumpStarts() {
          startTimer = null;
          for (var n = 0; n < 3 && startQueue.length; n++) {
            var m = startQueue.shift();
            if (m.__mmWant && !m.__mmV) playTile(m);
          }
          if (startQueue.length) startTimer = setTimeout(pumpStarts, 90);
        }
        syncAll = function () {
          var on = stripSeen && !document.hidden && tier !== 'off';
          var list = [].slice.call(medias()).filter(function (m) { return on && wantsPlay(m); });
          var tr = track.getBoundingClientRect(), mid = tr.left + tr.width / 2;
          var dist = function (m) { var r = m.getBoundingClientRect(); return Math.abs(r.left + r.width / 2 - mid); };
          if (capN > 0 && list.length > capN) {
            list.sort(function (a, b) { return dist(a) - dist(b); });
            list = list.slice(0, capN);
          }
          medias().forEach(function (m) {
            m.__mmWant = list.indexOf(m) > -1;
            if (!m.__mmWant) stopTile(m);
          });
          startQueue = list.filter(function (m) { return !m.__mmV; });
          if (startQueue.length > 3) {
            var d = new Map();
            startQueue.forEach(function (m) { d.set(m, dist(m)); });
            startQueue.sort(function (a, b) { return d.get(a) - d.get(b); });
          }
          if (startTimer == null && startQueue.length) pumpStarts();
          if (on && watchTimer == null) { grace(6000); watchTimer = setInterval(watch, 2500); }
          if (!on && watchTimer != null) { clearInterval(watchTimer); watchTimer = null; }
        };
        if (tier === 'lo' || capN > 0) ensureVisIO();
        // The 300px margin is there so a scroll never reveals a still tile. But a
        // strip sitting at the fold (the home page: hero is 100svh, strip starts
        // right under it) is inside that margin at load, so every preview used to
        // start decoding while the hero was the only thing on screen, and the
        // first tap on the hero button waited behind them (1-3s on a mid-range
        // phone, so people tapped twice). Until the visitor scrolls, only a strip
        // that is genuinely in view may start; the first scroll arms the margin.
        var armed = (window.pageYOffset || 0) > 4;
        var lastEntry = null;
        previewIO = new IntersectionObserver(function (entries) {
          lastEntry = entries[entries.length - 1];
          stripSeen = lastEntry.isIntersecting && (armed || lastEntry.boundingClientRect.top < window.innerHeight);
          syncAll();
        }, { root: null, rootMargin: '300px 0px 300px 0px', threshold: 0 });
        previewIO.observe(el);
        if (!armed) {
          window.addEventListener('scroll', function () {
            armed = true;
            if (lastEntry && lastEntry.isIntersecting && !stripSeen) { stripSeen = true; syncAll(); }
          }, { passive: true, once: true });
        }
        document.addEventListener('visibilitychange', syncAll);
        // Tab/BFCache restore: browsers drop media state on the way back in.
        window.addEventListener('pageshow', function () { if (stripSeen && !document.hidden) medias().forEach(kick); });
      }

      function measure() {
        half = track.scrollWidth / 2;
      }
      measure();
      // Phones fire resize when the address bar slides; only a width change can move scrollWidth.
      var lastW = window.innerWidth;
      window.addEventListener('resize', function (e) {
        if (e.isTrusted && window.innerWidth === lastW) return;
        lastW = window.innerWidth;
        measure();
      });

      function wrap() {
        if (half <= 0) return;
        if (track.scrollLeft >= half) track.scrollLeft -= half;
        else if (track.scrollLeft < 0) track.scrollLeft += half;
      }

      // translateX, not width: this runs every frame while the strip auto-scrolls, and width forces layout + paint.
      var lastFrac = -1;
      function syncFill() {
        if (!fill || half <= 0) return;
        var frac = Math.max(0, Math.min(1, track.scrollLeft / half));
        if (frac === lastFrac) return;
        lastFrac = frac;
        fill.style.transform = 'translateX(' + ((frac - 1) * 100) + '%)';
      }

      var paused = false;
      var resumeTimer = null;
      function pause() {
        paused = true;
        if (resumeTimer) { clearTimeout(resumeTimer); resumeTimer = null; }
      }
      function resumeSoon() {
        if (resumeTimer) clearTimeout(resumeTimer);
        resumeTimer = setTimeout(function () { paused = false; }, 1800);
      }

      function step() {
        if (!cards.length) return 0;
        var gap = parseFloat(getComputedStyle(track).columnGap) || 0;
        return cards[0].getBoundingClientRect().width + gap;
      }

      // A mouse eases the strip to a stop (see raf); a finger still stops it dead, so a drag never fights the scroll.
      var hovering = false;
      track.addEventListener('pointerenter', function (e) {
        if (e.pointerType === 'mouse') hovering = true; else pause();
      }, { passive: true });
      track.addEventListener('pointerleave', function (e) {
        if (e.pointerType === 'mouse') hovering = false; else resumeSoon();
      }, { passive: true });
      track.addEventListener('touchstart', pause, { passive: true });
      track.addEventListener('touchend', resumeSoon, { passive: true });

      if (prev) prev.addEventListener('click', function () {
        pause(); resumeSoon();
        track.scrollBy({ left: -step(), behavior: 'smooth' });
      });
      if (next) next.addEventListener('click', function () {
        pause(); resumeSoon();
        track.scrollBy({ left: step(), behavior: 'smooth' });
      });

      var ticking = false;
      track.addEventListener('scroll', function () {
        if (ticking) return;
        ticking = true;
        requestAnimationFrame(function () { ticking = false; syncFill(); });
      }, { passive: true });

      if (reduceMotion) { syncFill(); return; }

      var HOVER_STOP_S = 3, HOVER_RESUME_S = 1;
      var rate = 1; // share of full speed: falls to 0 over HOVER_STOP_S of hover, climbs back after
      var pos = track.scrollLeft;
      var lastTs = null;
      var rafId = null;
      function raf(ts) {
        if (lastTs == null) lastTs = ts;
        var dt = (ts - lastTs) / 1000;
        lastTs = ts;
        rate = hovering ? Math.max(0, rate - dt / HOVER_STOP_S) : Math.min(1, rate + dt / HOVER_RESUME_S);
        if (!paused && !manualPause && half > 0 && rate > 0) {
          // pos keeps the fraction scrollLeft rounds away: without it the slow end of the ease rounds to a dead stop.
          if (Math.abs(track.scrollLeft - pos) > 2) pos = track.scrollLeft; // a drag, arrow or wrap moved the strip
          pos += speed * rate * dt;
          track.scrollLeft = pos;
          wrap();
          syncFill();
        }
        rafId = requestAnimationFrame(raf);
      }
      function startRaf() {
        if (rafId != null) return;
        lastTs = null; // don't count the time spent off-screen/hidden as a jump
        rafId = requestAnimationFrame(raf);
      }
      function stopRaf() {
        if (rafId == null) return;
        cancelAnimationFrame(rafId);
        rafId = null;
      }

      var inView = false;
      function syncVisibility() {
        if (inView && !document.hidden) startRaf(); else stopRaf();
      }
      if ('IntersectionObserver' in window) {
        // isIntersecting is also true for a strip that merely TOUCHES the viewport
        // edge (ratio 0) — on the home page that is the strip sitting right under
        // the 100svh hero, which then auto-scrolled at 60fps while off screen.
        // Require real overlap; the 0.01 threshold makes the observer report the
        // touching → 1% transition (a plain threshold of 0 never would).
        new IntersectionObserver(function (entries) {
          var e = entries[entries.length - 1];
          inView = e.isIntersecting && e.intersectionRatio > 0;
          syncVisibility();
        }, { threshold: [0, 0.01] }).observe(el);
      } else {
        inView = true; // no IO support — fall back to always-on rather than never-on
        startRaf();
      }
      document.addEventListener('visibilitychange', syncVisibility);
    }

    function init(scope) {
      var root = (scope && scope.querySelectorAll) ? scope : document;
      root.querySelectorAll('[data-mm-vcar]').forEach(initVcar);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { init(document); });
    } else {
      init(document);
    }
    document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
  (function () {
    document.querySelectorAll('[data-mm-gallery]').forEach(function (gallery) {
      var slides = gallery.querySelectorAll('[data-mm-slide]');
      var thumbs = gallery.querySelectorAll('[data-mm-thumb]');
      function show(idx) {
        slides.forEach(function (el) {
          var active = parseInt(el.getAttribute('data-mm-slide'), 10) === idx;
          el.classList.toggle('is-active', active);
          if (active) { el.removeAttribute('aria-hidden'); }
          else { el.setAttribute('aria-hidden', 'true'); }
        });
        thumbs.forEach(function (el) {
          var active = parseInt(el.getAttribute('data-mm-thumb'), 10) === idx;
          el.classList.toggle('is-active', active);
          el.setAttribute('aria-selected', active ? 'true' : 'false');
        });
      }
      thumbs.forEach(function (t) {
        t.addEventListener('click', function () {
          show(parseInt(t.getAttribute('data-mm-thumb'), 10));
        });
      });
    });

    document.querySelectorAll('.mm-pdp-default__form').forEach(function (form) {
      var qtyInput = form.querySelector('[data-mm-qty-input]');
      form.querySelectorAll('[data-mm-qty]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var step = parseInt(btn.getAttribute('data-mm-qty'), 10) || 0;
          var next = (parseInt(qtyInput.value, 10) || 1) + step;
          if (next < 1) { next = 1; }
          qtyInput.value = next;
        });
      });

      var variantsScript = form.querySelector('[data-mm-variants]');
      if (!variantsScript) { return; }
      var variants;
      try { variants = JSON.parse(variantsScript.textContent); } catch (e) { return; }

      var idInput = form.querySelector('[data-mm-variant-id]');
      var priceEl = form.parentElement.querySelector('[data-mm-price]');
      var compareEl = form.parentElement.querySelector('[data-mm-compare]');
      var atc = form.querySelector('[data-mm-atc]');
      var atcLabel = form.querySelector('[data-mm-atc-label]');

      function moneyFmt(cents) {
        if (window.mmMoney) return window.mmMoney(cents);
        // Fallback for Shopify's money_format placeholder — not a theme
        // variable. Its braces are written as unicode escapes so the literal
        // is never parsed as a Liquid output tag inside this static block.
        var FALLBACK_FORMAT = '$' + '\u007B\u007Bamount\u007D\u007D';
        var format = (window.Shopify && Shopify.money_format) || FALLBACK_FORMAT;
        var amount = (cents / 100).toFixed(2);
        return format.replace(/\{\{\s*amount\s*\}\}/, amount).replace(/\{\{\s*amount_no_decimals\s*\}\}/, Math.round(cents / 100));
      }

      function findVariant() {
        var picked = [];
        form.querySelectorAll('[data-mm-option-input]').forEach(function (input) {
          if (input.type === 'radio' && !input.checked) { return; }
          picked[parseInt(input.getAttribute('data-mm-option-input'), 10)] = input.value;
        });
        return variants.find(function (v) {
          return v.options.every(function (val, i) { return val === picked[i]; });
        });
      }

      function update() {
        var v = findVariant();
        if (!v) { return; }
        idInput.value = v.id;
        if (priceEl) { priceEl.textContent = moneyFmt(v.price); }
        if (compareEl) {
          if (v.compare_at_price && v.compare_at_price > v.price) {
            compareEl.textContent = moneyFmt(v.compare_at_price);
            compareEl.hidden = false;
          } else {
            compareEl.hidden = true;
          }
        }
        form.querySelectorAll('[data-mm-option-display]').forEach(function (el) {
          var i = parseInt(el.getAttribute('data-mm-option-display'), 10);
          el.textContent = v.options[i];
        });
        if (atc && atcLabel) {
          if (v.available) {
            atc.disabled = false;
            atc.removeAttribute('aria-disabled');
            atcLabel.innerHTML = 'Add to Cart — <span data-mm-atc-price>' + moneyFmt(v.price) + '</span>';
          } else {
            atc.disabled = true;
            atc.setAttribute('aria-disabled', 'true');
            atcLabel.textContent = 'Sold Out';
          }
        }
      }

      form.querySelectorAll('[data-mm-option-input]').forEach(function (input) {
        input.addEventListener('change', update);
      });
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
